"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bindAll = _interopRequireDefault(require("lodash/bindAll"));

var _Navigateleft = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Navigateleft"));

var _Navigateright = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Navigateright"));

/* eslint-disable react/require-default-props */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
var computePageNumbers = function computePageNumbers(min, max, current) {
  var bookendPadding = 3;
  var middlePadding = 1;
  var pageNumbers = [];

  var bound = function bound(n) {
    return Math.max(min, Math.min(max, n));
  }; // Construct the ranges [min to left, start to end, right to max]


  var left = bound(min + bookendPadding - 1);
  var right = Math.max(left + 1, bound(max - bookendPadding + 1));
  var start = Math.max(left + 1, bound(current - middlePadding));
  var end = Math.min(right - 1, bound(current + middlePadding));

  for (var i = min; i <= left; i += 1) {
    pageNumbers.push(i);
  }

  for (var _i = start; _i <= end; _i += 1) {
    pageNumbers.push(_i);
  }

  for (var _i2 = right; _i2 <= max; _i2 += 1) {
    pageNumbers.push(_i2);
  }

  return pageNumbers;
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Pagination, _React$Component);

  var _super = (0, _createSuper2.default)(Pagination);

  function Pagination(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Pagination);
    _this = _super.call(this, props);
    (0, _bindAll.default)((0, _assertThisInitialized2.default)(_this), ['createPageLink']);
    return _this;
  } // TODO: use this function; handle prev/next buttons


  (0, _createClass2.default)(Pagination, [{
    key: "handleClick",
    value: function handleClick(target) {
      var num = target;

      if (target === 'next') {
        num = this.props.current + 1;
      } else if (target === 'prev') {
        num = this.props.current - 1;
      }

      this.props.onClick(num);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event, target) {
      if (event.which === 13 || event.which === 32) {
        // Space or enter
        this.handleClick(target);
      }
    }
  }, {
    key: "createPageLink",
    value: function createPageLink(num) {
      var _this2 = this;

      var current = this.props.current === num;
      return /*#__PURE__*/_react.default.createElement("a", {
        key: num,
        className: "page-link".concat(current ? ' current-page' : ''),
        role: "button",
        tabIndex: "0",
        "aria-label": "Go to page ".concat(num),
        "aria-current": current,
        onClick: function onClick() {
          return _this2.handleClick(num);
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.handleKeyPress(e, num);
        }
      }, num);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var prevDisabled = this.props.current === this.props.min ? 'disabled' : '';
      var nextDisabled = this.props.current === this.props.max ? 'disabled' : '';
      var pageNumbers = computePageNumbers(this.props.min, this.props.max, this.props.current);
      var pageList = pageNumbers.map(this.createPageLink);

      for (var i = pageNumbers.length - 1; i > 0; i -= 1) {
        if (pageNumbers[i] - pageNumbers[i - 1] > 1) {
          pageList.splice(i, 0, '…');
        }
      }

      return /*#__PURE__*/_react.default.createElement("nav", {
        className: "pagination",
        "aria-label": "Pagination navigation"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "prev-page-link",
        disabled: prevDisabled,
        "aria-label": "Go to previous page",
        onClick: function onClick() {
          return _this3.handleClick('prev');
        }
      }, /*#__PURE__*/_react.default.createElement(_Navigateleft.default, null)), pageList, /*#__PURE__*/_react.default.createElement("button", {
        className: "next-page-link ",
        disabled: nextDisabled,
        "aria-label": "Go to next page",
        onClick: function onClick() {
          return _this3.handleClick('next');
        }
      }, /*#__PURE__*/_react.default.createElement(_Navigateright.default, null)));
    }
  }]);
  return Pagination;
}(_react.default.Component);

exports.default = Pagination;
(0, _defineProperty2.default)(Pagination, "displayName", 'Pagination');
(0, _defineProperty2.default)(Pagination, "propTypes", {
  min: _propTypes.default.number.isRequired,
  max: _propTypes.default.number.isRequired,
  current: _propTypes.default.number.isRequired,
  onClick: _propTypes.default.func
});